import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/apiService";
import { STORAGE_KEYS } from "../constants/config";

export const useAuth = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const login = async (userName, password) => {
    setError("");
    setLoading(true);

    try {
      const data = await authService.login(userName, password);
      localStorage.setItem(STORAGE_KEYS.TOKEN, data.accessToken);
      localStorage.setItem(STORAGE_KEYS.USERNAME, userName);
      localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken);
      localStorage.removeItem("userFullName");
      navigate("/order");
    } catch (err) {
      const message =
        err.response?.data?.error ||
        err.response?.data?.errorMessage ||
        "Server error. Please try again.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await authService.logout();
      localStorage.removeItem(STORAGE_KEYS.TOKEN);
      localStorage.removeItem(STORAGE_KEYS.USERNAME);
      localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
      localStorage.removeItem("userFullName");
      localStorage.removeItem("companyName");
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
      navigate("/login");
    }
  };

  const signup = async (formData) => {
    setError("");
    setLoading(true);

    try {
      const response = await authService.signup(formData);
      return { success: true, data: response };
    } catch (err) {
      const message = err.response?.data?.error || "Signup failed. Try again.";
      setError(message);
      return { success: false, error: message };
    } finally {
      setLoading(false);
    }
  };

  return { login, logout, signup, error, loading };
};
